import React from 'react';
import {
  CreatableDropdown,
  Dropdown,
  SelectGroup,
  SelectOption
} from '@superops/ui-design-system';

import {
  IndicatorSeparator,
  DropdownIndicator,
  formatGroupLabel
} from '@nile/components';

type SelectOptionType = SelectOption | SelectOption[];

type SelectValueType = {
  [x: string]: any;
  label: string;
  value: any;
};

interface MinimalDropDownProps {
  name?: string;
  value?: SelectValueType | SelectValueType[] | null;
  styles?: Record<string, any>;
  options: (SelectOption | SelectGroup)[];
  placeholder?: string;
  onChange: (option: SelectOptionType) => void;
  isDisabled?: boolean;
  isMulti?: boolean;
  isClearable?: boolean;
  components?: any;
  closeMenuOnScroll?: any;
}

export const MinimalDropDown = ({
  name,
  value,
  styles,
  options = [],
  placeholder,
  onChange,
  isDisabled,
  components,
  ...restProps
}: MinimalDropDownProps) => (
  <Dropdown
    name={name}
    value={value || null}
    onChange={onChange}
    options={options}
    components={{
      IndicatorSeparator,
      DropdownIndicator,
      ...components
    }}
    classNamePrefix="value_selector"
    formatGroupLabel={formatGroupLabel}
    menuPlacement="auto"
    menuPortalTarget={document.body}
    placeholder={placeholder}
    closeMenuOnScroll={(e) => {
      return (
        e.target &&
        e.target.classList &&
        !(e.target.classList.value.indexOf('menu-list') > -1)
      );
    }}
    styles={{
      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      menu: (base) => ({ ...base, zIndex: 9999 }),
      ...styles
    }}
    isDisabled={isDisabled}
    {...restProps}
  />
);

export const MinimalCreatableDropDown = ({
  name,
  value,
  options = [],
  placeholder,
  onChange,
  isDisabled,
  ...restProps
}: MinimalDropDownProps) => {
  return (
    <CreatableDropdown
      name={name}
      value={value || null}
      onChange={onChange}
      options={options}
      components={{
        IndicatorSeparator,
        DropdownIndicator
      }}
      classNamePrefix="value_selector"
      formatGroupLabel={formatGroupLabel}
      menuPlacement="auto"
      menuPortalTarget={document.body}
      placeholder={placeholder}
      closeMenuOnScroll={(e) => {
        return (
          e.target &&
          e.target.classList &&
          !(e.target.classList.value.indexOf('menu-list') > -1)
        );
      }}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menu: (base) => ({ ...base, zIndex: 9999 })
      }}
      isDisabled={isDisabled}
      {...restProps}
    />
  );
};
